(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-order-form"] && !Shopify.designMode) return;
  try {
    

// Update cart quantity indicators based on cart data
function updateCartQuantityIndicators(cartData) {
  // Create a map of variant_id to quantity
  const cartMap = {};
  if (cartData && cartData.items) {
    cartData.items.forEach(item => {
      const variantId = item.variant_id || item.id;
      cartMap[variantId] = item.quantity;
    });
  }
  
  // Update all cart quantity displays
  document.querySelectorAll('.cart-quantity-indicator').forEach(element => {
    const variantId = parseInt(element.dataset.variantId);
    const qty = cartMap[variantId] || 0;
    const quantitySpan = element.querySelector('.quantity-cart');
    if (quantitySpan) {
      quantitySpan.textContent = qty;
    }
  });
}

// Fetch cart data and update indicators
function fetchAndUpdateCartQuantities() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cartData => {
      updateCartQuantityIndicators(cartData);
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

document.addEventListener('DOMContentLoaded', function () {
  // Fetch initial cart quantities
  fetchAndUpdateCartQuantities();
  
  // Subscribe to PubSub cart updates if available
  if (typeof subscribe !== 'undefined') {
    subscribe('cart-update', function(event) {
      if (event.cartData) {
        updateCartQuantityIndicators(event.cartData);
      }
    });
  }
  
  // Handle pagination clicks
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('.page-link')) {
      e.preventDefault();
      const link = e.target;
      const url = new URL(link.href);
      const sectionId = url.searchParams.get('section_id');
      const blockId = url.searchParams.get('block_id');

      fetch(`${url.pathname}${url.search}`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBlock = doc.querySelector(`#collection-block-${blockId}`);
          const currentBlock = document.querySelector(`#collection-block-${blockId}`);
          if (currentBlock && newBlock) {
            currentBlock.replaceWith(newBlock);
            const event = new CustomEvent('orderFormPageChanged', { detail: { sectionId, blockId } });
            document.dispatchEvent(event);
            // Update cart quantities after pagination
            fetchAndUpdateCartQuantities();
          }
        });
    }
  });

  // Handle form submissions
  document.body.addEventListener('submit', function(e) {
    if (e.target.matches('.collection-order-form')) {
      e.preventDefault();
      handleOrderFormSubmit(e.target);
    }
  });
});

function handleOrderFormSubmit(form) {
  const submitButton = form.querySelector('.order-form-button');
  const originalText = submitButton.textContent;
  
  // Disable button and show loading state
  submitButton.disabled = true;
  submitButton.textContent = orderFormStrings.addingToCart;

  // Collect all items with quantities > 0
  const items = [];
  const quantityInputs = form.querySelectorAll('.quantity-input');
  
  quantityInputs.forEach(input => {
    if (input.disabled || input.dataset.available === 'false') return;
    const quantity = parseInt(input.value, 10) || 0;
    const variantId = input.getAttribute('data-variant');

    if (quantity > 0 && variantId) {
      items.push({
        id: variantId,
        quantity: quantity
      });
    }
  });

  if (items.length === 0) {
    // No items selected
    submitButton.disabled = false;
    submitButton.textContent = originalText;
    alert(orderFormStrings.itemsNotAddedErrorMessage);
    return;
  }

  // Add items to cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Success - show success message and update cart count
    submitButton.textContent = orderFormStrings.addedToCart;
    updateCartCount();
    
    // Fetch updated cart and update quantity indicators
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cartData => {
        updateCartQuantityIndicators(cartData);
        // Publish cart update event for other components
        if (typeof publish !== 'undefined') {
          publish('cart-update', { cartData: cartData, source: 'order-form' });
        }
      });
    
    // Reset all quantity inputs to zero
    quantityInputs.forEach(input => {
      input.value = 0;
    });
    
    // Reset button after 2 seconds
    setTimeout(() => {
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }, 2000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    submitButton.disabled = false;
    submitButton.textContent = originalText;
    alert(orderFormStrings.errorAddingToCart);
  });
}

function updateCartCount() {
  // Fetch updated cart to get current item count
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count in bubble spans
      document.querySelectorAll('.cart-count-bubble span').forEach(element => {
        element.textContent = cart.item_count;
      });

      // Show/hide cart count bubble based on item count
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        if (cart.item_count > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      });

      // Dispatch custom event for themes that listen for cart updates
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

function initQtyFields() {
  document.querySelectorAll('[max]').forEach(function(element) {
    element.addEventListener('blur', function() {
      var max = parseInt(this.getAttribute('max'), 10);
      var value = parseInt(this.value, 10) || 0;
      if (value > max) {
        alert(orderFormStrings.quantityErrorMessage);
        this.value = max;
      }
    });
    element.addEventListener('focus', function() {
      this.select();
    });
  });
}

document.addEventListener('DOMContentLoaded', initQtyFields);
document.addEventListener('orderFormPageChanged', initQtyFields);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
